import React from "react";
import { openAddEventModal, setAgendaItemPosition } from "../redux/actions";
import {
    selectAgendaItemDragging,
    selectAgendaItemPosition
} from "../redux/selectors";
import { connect } from "react-redux";

class TimeblockControl extends React.Component {
    render() {
        const style = {
            gridColumnStart: this.props.column,
            gridColumnEnd: this.props.column,
            gridRowStart: this.props.row + 1,
            gridRowEnd: this.props.row + 1
        };
        return (
            <div
                onDragOver={e => {
                    if (this.props.agendaItemDragging === false) {
                        this.props.setEventPosition(
                            this.props.index,
                            this.props.row
                        );
                    } else {
                        if (
                            this.props.agendaItemPosition.index !==
                                this.props.index ||
                            this.props.agendaItemPosition.row !==
                                this.props.row ||
                            this.props.agendaItemPosition.parentTrackIndex !==
                                this.props.parentTrackIndex ||
                            this.props.agendaItemPosition.childTrackIndex !==
                                this.props.childTrackIndex
                        ) {
                            if (
                                this.props.type ===
                                this.props.agendaItemDragging.resource
                            ) {
                                this.props.setAgendaItemPosition(this.props);
                            }
                        }
                    }
                }}
                onDoubleClick={e => {
                    this.props.openAddEventModal(this.props);
                }}
                className="TimeblockControl"
                style={style}
            />
        );
    }
}

export default connect(
    store => {
        return {
            agendaItemDragging: selectAgendaItemDragging(store),
            agendaItemPosition: selectAgendaItemPosition(store)
        };
    },
    { openAddEventModal, setAgendaItemPosition }
)(TimeblockControl);
